var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoSmallSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137,
    height: 92,
    viewBox: "0 0 137 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:none;stroke:#001f4c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 137,
    height: 92,
    rx: 4,
    transform: "translate(784.916 19)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-784.916 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -973.124, -366.933)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 66.445,
    height: 43.333,
    rx: 1,
    transform: "translate(1632.5 867.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1655.944,881.167,1641.5,872.5v17.333Z",
    transform: "translate(17 9.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1679.833,891.167l-5.778-8.667h-31.778l-5.778,8.667",
    transform: "translate(7.556 28.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSmallSymbol);
export default __webpack_public_path__ + "static/media/video-small-symbol.6de69385d9740377a9343bbeb3d41849.svg";
export { ForwardRef as ReactComponent };